import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AppInformationService, AuthService, GenesisUnitOfWork } from 'app/core/core.module';
import { OrderLineDetail, PartType } from 'app/core/model/entity-model';
import { OrderDetailComponent } from 'app/orders/order-detail/order-detail.component';
import { SharedModule } from 'app/shared/shared.module';
import { DxDataGridComponent } from 'devextreme-angular';
import _ from 'lodash';
import moment from 'moment';
import { BsModalService } from 'ngx-bootstrap/modal';

@Component({
    selector: 'app-parts-date-overview',
    templateUrl: './parts-date-overview.component.html',
    styleUrls: ['./parts-date-overview.component.scss'],
    standalone: false
})
export class PartsByDateOverviewComponent implements OnInit {
    parts: any[];
    groupedParts: any[];
    filter: any = {};
    statusList: any[] = [];
    partTypes: any[] = [];
    partInfos: any[];

    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;
    onExporting = SharedModule.onExporting;

    constructor(private uow: GenesisUnitOfWork, private router: Router, public auth: AuthService, private modalService: BsModalService, private appInfo: AppInformationService) {}

    async ngOnInit() {
        this.partTypes = this.uow.lookups.partTypes;
        this.statusList = this.uow.lookups.orderLineStatuses;
        this.clear();
        this.filter.selectedPartTypes = [PartType.Types.Trailer];
        this.filter.selectedStatuses = [OrderLineDetail.Statuses.New];
        this.partInfos = [];
        await this.getData();
    }

    async getData() {
        this.appInfo.pleaseWaitShow();
        this.groupedParts = await this.uow.getPartsByDateOverviewGrouped(this.filter.selectedStatuses, this.filter.selectedPartTypes, this.filter.startDate, this.filter.endDate);
        this.appInfo.pleaseWaitHide();
    }

    async search() {
        await this.getData();
    }
    clear() {
        this.filter = { startDate: moment(new Date()).add(-1, 'month').startOf('day').toDate(), endDate: moment(new Date()).startOf('day').toDate() };
    }

    // this method is used to clear the selection when the user searches for something
    onOptionChanged(e) {
        if (e.fullName === 'searchPanel.text') {
            e.component.__searchChanged = true;
        }
        const filterCheck = _.includes(e.fullName, 'filterValue');
        if (filterCheck) {
            this.dataGrid.instance.clearSelection();
        }
    }

    // this method is used to clear the selection when the user searches for something
    onContentReady(e) {
        if (e.component.__searchChanged) {
            //__searchChanged is for the search box
            e.component.__searchChanged = false;
            this.dataGrid.instance.clearSelection();
        }
    }

    async rowDoubleClick(e) {
        console.log(e);
        if (!!e.data) this.partInfos = await this.uow.getPartsByDateUnGrouped(this.filter.selectedStatuses, [e.data.partId]);
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons',
            },
            {
                template: 'leadingToolbarText',
                location: 'before',
            },
            {
                template: 'toolbarText',
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'revert',
                    elementAttr: { title: 'Reset Filters' },
                    onClick: () => {
                        e.component.clearFilter();
                    },
                },
                location: 'after',
            }
            // {
            //     widget: 'dxButton',
            //     options: {
            //         icon: 'refresh',
            //         elementAttr: { title: 'Reset Grid Layout' },
            //         onClick: () => {
            //             e.component.state({});
            //         },
            //     },
            //     location: 'after',
            // }
        );
    }

    async getParts() {
        // let partIds = [];
        // const mode = null;
        // const modalRef = this.modalService.show(PartSearchComponent, {
        //     class: 'modal-lg',
        //     ignoreBackdropClick: true,
        //     keyboard: false,
        //     initialState: {
        //         showAsDialog: true,
        //         mode: mode,
        //     },
        // });
        // modalRef.content.result.subscribe(async (result) => {
        //     if (result.success) {
        //         console.log(result);
        //         // this.saving = true;
        //         // const parts = (await this.uow.parts.byIds(result.partIds)) as Part[];
        //         // for (let partIndex = 0; partIndex < parts.length; partIndex++) {
        //         //     this.addPurchaseOrderLine(parts[partIndex], 1, this.purchaseOrder);
        //         // }
        //         // await this.save();
        //         await this.getData(result.partIds);
        //         // this.saving = false;
        //     }
        //     modalRef.hide();
        // });
    }

    calcStatus = (rowData) => {
        return this.statusList.find((i) => i.id === rowData.statusId).name;
    };

    async open(orderId: number) {
        const modalRef = this.modalService.show(OrderDetailComponent, {
            class: 'modal-lg',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                orderId: orderId,
                showAsDialog: true,
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result.success) {
                // this.appInfo.pleaseWaitShow();
                // await this.getData();
                // this.appInfo.pleaseWaitHide();
            }
            modalRef.hide();
            this.uow.rollback();
        });
    }
}
